import { CompanyDestination } from 'mbs-ui-shared@models';
import { StorageDestinationWithLimit } from 'mbs-ui-shared@models/StorageAccount';

export function mapToCompanyDestinations(destination: StorageDestinationWithLimit): CompanyDestination {
  return {
    bucketId: destination.id,
    bucketName: destination.bucketName,
    displayStorageName: destination.storageAccountName,
    displayDestinationName: destination.destinationName,
    storageAccountId: destination.accountId,
    storageAccountType: destination.storageType,
    storageAccountState: destination.storageAccountState,
    region: destination.region?.systemName,
    regionDisplayName: destination.region?.displayName,
    storageLimitId: destination.storageLimitId,
    storageLimitName: destination.storageLimitName
    // CompanyDestination declares storageLimitId as string, but the app has always stored the numeric StorageLimit.id in it
  } as unknown as CompanyDestination;
}
